import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { useAppTheme } from "@hooks/useAppTheme";
import { Box } from "@memorang/ui";
import { ProgressBar } from "react-native-paper";

// Replaces the app bar's in-session progress bar on both ProEthica report
// screens, standing in as the finished (fully filled) session bar.
export const ProethicaCompletedProgressBar = () => {
	const theme = useAppTheme();
	return (
		<Box flexDirection="row" alignItems="center">
			<Box flex={1}>
				<ProgressBar
					progress={1}
					color={theme.colors.primary}
					style={{
						height: 8,
						borderRadius: 4,
						backgroundColor: theme.colors.surfaceVariant,
					}}
				/>
			</Box>
			<Box
				width={44}
				height={44}
				borderRadius={22}
				backgroundColor={theme.colors.primary}
				alignItems="center"
				justifyContent="center"
				style={{ marginLeft: -3 }}
			>
				<Icon name="check" size={24} color={theme.colors.white} />
			</Box>
		</Box>
	);
};
